export function createRouteToPatientChartPage(patientId: string, stayId: string, certificationPeriodId?: string) {
	return `/charts/${patientId}/${stayId}/${certificationPeriodId ? certificationPeriodId : 'current'}`;
}
